import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

import ProjectSettingsDropdown from "../ProjectSettingsDropdown";
import Card, {CardFooter, CardHeader} from "UI/Card";
import Badge from "UI/Badge";

import { BookmarkIcon } from "@heroicons/react/solid";
import {Link} from "react-router-dom";
import Feature from "Components/Feature";

export default class ProjectCard extends React.Component
{
    static propTypes = {
        project: PropTypes.object.isRequired,
        removeProject: PropTypes.func.isRequired
    };

    render()
    {
        const { project } = this.props;

        const settings = <ProjectSettingsDropdown
            project={project}
            onRemove={() => this.props.removeProject(project.id)}
        />

        const title = <>
            <ProjectColourDot colour={project.colour} />
            <Feature when={features => features.projectsPage}>
                <Link to={`/projects/${project.id}`}>{ project.name }</Link>
            </Feature>
            <Feature when={features => ! features.projectsPage}>
                { project.name }
            </Feature>
        </>;

        const header = <CardHeader title={title} action={settings} />;

        const footer = <CardFooter className='flex flex-row-reverse space-x-2'>
            <Badge>
                <BookmarkIcon className='mr-1 h-3 w-3' /> {project.stories.length}
            </Badge>
        </CardFooter>;

        return <Card header={header} footer={footer}>
            <p className='text-gray-800 text-sm'>
                { project.description }
            </p>
        </Card>;
    }
}

const ProjectColourDot = ({colour}) => {
    const classes = classNames(
        'inline-block w-3 h-3 mr-2 border rounded',
        {
            'bg-gray-100 border-gray-200 text-gray-800': ! colour || colour === 'gray',
            'bg-red-100 border-red-200 text-red-800': colour === 'red',
            'bg-orange-100 border-orange-200 text-orange-800': colour === 'orange',
            'bg-yellow-100 border-yellow-200 text-yellow-800': colour === 'yellow',
            'bg-green-100 border-green-200 text-green-800': colour === 'green',
            'bg-teal-100 border-teal-200 text-teal-800': colour === 'teal',
            'bg-blue-100 border-blue-200 text-blue-800': colour === 'blue',
            'bg-indigo-100 border-indigo-200 text-indigo-800': colour === 'indigo',
            'bg-purple-100 border-purple-200 text-purple-800': colour === 'purple',
            'bg-pink-100 border-pink-200 text-pink-800': colour === 'pink'
        }
    );

    return <div className={classes} />;
}
